export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12861.59d708d9.jpg";